import React, { useState } from 'react';
import { Row, Col, Button, message } from 'antd';
import styles from './styles.module.less';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { get_Invoice_data } from '../redux/slice';

const Membership = ({ payment_data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pdfUrl, setPdfUrl] = useState(null);
  // const [loading, setLoading] = useState(false);
  // const [disabled, setDisabled] = useState(false);
  const [loadingTxn, setLoadingTxn] = useState({});

  // Extract membership and transaction data safely
  // const membershipData =
  //   Array.isArray(user_data) && user_data.length > 0
  //     ? user_data[0]
  //     : user_data || {};

  // const transactions = membershipData?.Payments || [];
  const transactions = payment_data || [];

  // Filter successful transactions
  const successfulTransactions = transactions.filter((txn) => txn.success);

  // Navigate to membership payment page
  const handleChangeForm = () => navigate('/membership_payment');

  // Helper function: Format transaction data
  const formatTransaction = (txn) => {
    const transactionDate = txn.payment_time
      ? new Date(txn.payment_time).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        })
      : 'N/A';
    const transactionId = txn.trn ? `ES-${txn.trn.slice(0, 8)}` : 'N/A';
    const membership = txn.notes?.productName;
    const planType = txn.notes?.planType;
    // Find latest active subscription

    return {
      transactionDate,
      transactionId,
      membershipType:
        membership && planType ? `${membership} - ${planType}` : 'N/A'
      // expiresOn
    };
  };

  const activeSubscription = transactions
    .flatMap((txn) => txn.UserSubscriptions || [])
    .filter((sub) => sub.is_active)
    .sort(
      (a, b) => new Date(b.end_date).getTime() - new Date(a.end_date).getTime()
    )[0]; // Get the most recent one

  const expiresOn = activeSubscription
    ? new Date(activeSubscription.end_date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })
    : 'N/A';

  // Get the latest membership details
  const latestTransaction = successfulTransactions[0] || {};
  const { membershipType } = formatTransaction(latestTransaction);

  // const handleViewInvoice = async (txn) => {
  //   console.log('View invoice for transaction:', txn);
  //   try {
  //     const response = await dispatch(get_Invoice_data({ id: txn }));

  //     // Assuming response.payload contains the raw PDF file (Blob or Uint8Array)
  //     if (response?.payload) {
  //       const blob = new Blob([response.payload], { type: 'application/pdf' });
  //       const pdfUrl = URL.createObjectURL(blob);

  //       // Open PDF in a new tab
  //       window.open(pdfUrl, '_blank');
  //     } else {
  //       console.error('Invoice PDF not found');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching invoice:', error);
  //   }
  // };

  // const handleViewInvoice = async (txn) => {
  //   try {
  //     const response = await dispatch(get_Invoice_data({ id: txn }));

  //     console.log('API Response:', response); // Debugging

  //     if (response?.payload?.data) {
  //       const pdfUrl = response.payload.data; // Direct URL from backend
  //       // window.open(pdfUrl, '_blank'); // Open PDF in new tab
  //       window.open(pdfUrl, '_blank', 'noopener,noreferrer'); // Open PDF in a new tab
  //     } else {
  //       console.error('Invoice PDF URL not found or empty.');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching invoice:', error);
  //   }
  // };

  const handleViewInvoice = async (txn) => {
    setLoadingTxn((prev) => ({ ...prev, [txn]: true })); // Set loading for the clicked button
    try {
      // setLoading(true);
      // setDisabled(true);
      const response = await dispatch(get_Invoice_data({ id: txn }));

      console.log('API Response:', response); // Debugging

      if (response?.payload?.data) {
        const url = response.payload.data;
        setPdfUrl(url);
        const successMsg =
          response?.payload?.message || 'Invoice loaded successfully!';
        message.success(successMsg);
      } else {
        console.error('Invoice PDF URL not found or empty.');
        const errorMsg =
          response?.payload?.message ||
          'Failed to load invoice. Please try again.';
        message.error(errorMsg);
      }
    } catch (error) {
      console.error('Error fetching invoice:', error);
      const errorMsg =
        error?.response?.data?.message ||
        'An error occurred while fetching the invoice.';
      message.error(errorMsg);
    } finally {
      // setLoading(false);
      // setDisabled(false);
      setLoadingTxn((prev) => ({ ...prev, [txn]: false })); // Reset loading for this transaction
    }
  };

  return (
    <>
      {/* Membership Info Section */}
      <Row className={styles.member}>
        <Col className={styles.colStyle}>
          <span className={styles.mem}>Membership Type</span>
          <span className={styles.mem1}>{membershipType || 'N/A'}</span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.mem}>Expires On</span>
          <span className={styles.mem1}>{expiresOn || 'N/A'}</span>
        </Col>
      </Row>

      {/* Transaction History Title */}
      <Row className={styles.history}>Transaction History</Row>

      {/* Transaction Table */}
      {successfulTransactions.length > 0 ? (
        <>
          <div className={styles.managetransacation}>
            {/* Table Headers */}
            <Row className={styles.transactionHeader}>
              {['Date', 'Membership Type', 'Transaction ID', ''].map(
                (label, idx) => (
                  <Col key={idx} className={styles.columnStyle}>
                    <span className={styles.label}>{label}</span>
                  </Col>
                )
              )}
            </Row>

            {/* Transaction Rows */}
            {successfulTransactions.map((txn, index) => {
              const { transactionDate, transactionId, membershipType } =
                formatTransaction(txn);
              return (
                <Row key={index} className={styles.transition}>
                  <Col className={styles.columnStyle}>
                    <span className={styles.value}>{transactionDate}</span>
                  </Col>
                  <Col className={styles.columnStyle}>
                    <span className={styles.value}>{membershipType}</span>
                  </Col>
                  <Col className={styles.columnStyle}>
                    <span className={styles.value}>{transactionId}</span>
                  </Col>
                  {/* <Col className={styles.colStyle}> */}
                  <Col className={styles.columnStyle}>
                    {/* <span
                      className={styles.viewInvoice}
                      onClick={() => handleViewInvoice(txn?.id)}
                      style={{ cursor: 'pointer' }}
                      loading={loading}
                      disabled={disabled}
                    >
                      <u>View Invoice</u>
                    </span> */}
                    <Button
                      type="link"
                      className={styles.viewInvoice}
                      onClick={() => handleViewInvoice(txn?.id)}
                      loading={loadingTxn[txn.id] || false} // Loader will show when clicking
                      disabled={loadingTxn[txn.id] || false} // Button disabled during API call
                      style={{ width: '105px', height: '20px' }}
                    >
                      <u>View Invoice</u>
                    </Button>
                  </Col>
                </Row>
              );
            })}
          </div>
        </>
      ) : (
        <Row className={styles.noTransactions}>
          No successful transactions found.
        </Row>
      )}

      {/* View All Plans Button */}
      <Row className={styles.view}>
        <Button
          type="primary"
          // className={styles.viewBtn}
          className={styles.submitbutton}
          onClick={handleChangeForm}
        >
          View All Plans
        </Button>
      </Row>

      {pdfUrl && (
        <iframe
          src={pdfUrl}
          width="100%"
          height="600px"
          style={{ border: 'none' }}
        />
      )}
    </>
  );
};

export default Membership;
